import styled from '@emotion/styled';
import phoneBg from './/..//..//images/deskBgImg.png'

export const AppContainer = styled.div`
   margin-left: auto;
  margin-right: auto;
  
//   background-image: url(${phoneBg});
//   height: 100vh;
//   background-size: 768px 414px;
//   background-position: center;
//   background-repeat: no-repeat;
//   position: fixed;
//   transform: translate(-50%, -50%);
//   top: 0;
//   left: 50%;
//   top: 50%;
//   width: 768px;
// box-shadow: 0px 0px 100px 50px #000;
`

export const BgImg=styled.div``

export const ErrorMessageContainer = styled.div`
    display: flex;
    height: 100vh;
    flex-direction: column;
    justify-content: center;  
    align-items: center;      
    padding: 10px;
    `


export const ErrorMessage = styled.p`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 36px;
    `

export const ApiTitleH1 = styled.h1`
    margin:0;
    padding-bottom: 10px;
    `

export const ApiTitleH2 = styled.h2`
    margin:0;
    padding-top: 20px;
    padding-bottom: 10px;
    `

//             Welcome 
// to  Phonebook app!

//  Register now and 
//  start conveniently 
//  organizing your 
//  contacts.